import type { ICommonContext } from '~/entities/auth'

import { SupporterModuleSlugEnum } from '~/shared/const'
import { permissions } from '~/shared/lib'

export type AccessFunction = [permission: string, ctx?: Partial<ICommonContext> | null, isBackend?: boolean]

export interface ISubModuleConfig {
  submodulePermissions: {
    PERMISSION: string
    ROUTE: string
    CREATE: {
      ROUTE: string
      PERMISSION: string
      ORGANIZATION: {
        ROUTE: string
        PERMISSION: string
      }
    }
    EDIT: {
      ROUTE: string
      PERMISSION: string
      ORGANIZATION: {
        ROUTE: string
        PERMISSION: string
      }
    }
    MERGE_LIST: {
      ROUTE: string
      PERMISSION: string
    }
    REPORT: {
      ROUTE: string
      PERMISSION: string
      TEMPLATES: {
        ROUTE: string
        PERMISSION: string
        CREATE: {
          ROUTE: string
          PERMISSION: string
        }
        EDIT: {
          ROUTE: string
          PERMISSION: string
        }
      }
      SEND_MESSAGE: {
        ROUTE: string
        PERMISSION: string
      }
      SHARE_SUPPORTERS: {
        ROUTE: string
        PERMISSION: string
      }
      SHOW_EXPORT_REPORT_BTN: {
        PERMISSION: string
      }
    }
    SHOW_DELETE_SUPPORTER_BTN: {
      PERMISSION: string
    }
  }
  title: string
  moduleSlug: SupporterModuleSlugEnum
  access: {
    canCreateSupporter: AccessFunction
    canEditSupporter: AccessFunction
    canTableSupporter: AccessFunction
    canDeleteSupporter: AccessFunction
  }
}

export const SUPPORTERS_SUBMODULE_CONFIG = {
  WORKSPACE: {
    submodulePermissions: permissions.PROJECTS.WORKSPACE.SUPPORTERS,
    title: 'Реестр',
    moduleSlug: SupporterModuleSlugEnum.Supporters,
    access: {
      canCreateSupporter: [permissions.PROJECTS.WORKSPACE.SUPPORTERS.SHOW_CREATE_SUPPORTER_BTN.PERMISSION, null, true],
      canEditSupporter: [permissions.PROJECTS.WORKSPACE.SUPPORTERS.SHOW_EDIT_SUPPORTER_BTN.PERMISSION, null, true],
      canTableSupporter: [permissions.PROJECTS.WORKSPACE.SUPPORTERS.SHOW_TABLE_SUPPORTER_BTN.PERMISSION, null, true],
      canDeleteSupporter: [permissions.PROJECTS.WORKSPACE.SUPPORTERS.SHOW_DELETE_SUPPORTER_BTN.PERMISSION, null, true],
    },
  } as ISubModuleConfig,
}
